export default __webpack_public_path__ + "static/customer-placeholder-2a826ff28c03ff86283b96f12a114568.png";